// extracted by mini-css-extract-plugin
export var divider = "_42-0";
export var dividerText = "_42-1";